import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
// Import only globally-used icons for better tree-shaking
// Landing-specific icons are imported directly in their components
import {
  faCheck,
  faUser,
  faCog,
  faSignOutAlt,
  faSpinner,
  faBars,
  faTimes,
  faChevronDown,
  faSearch,
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faDownload,
  faUpload,
  faEnvelope,
  faPhone,
  faCalendar,
  faClock,
  faExclamationTriangle,
  faInfoCircle,
  faQuestionCircle,
  faHome,
  faUsers,
  faArrowRight,
  faFilePdf,
  faFileImage,
  faFileMedical,
  faNotesMedical,
  faStethoscope,
  faHeartbeat,
  faLayerGroup,
} from '@fortawesome/free-solid-svg-icons';
import { ThemeProvider } from '@/shared/hooks/useTheme';
import App from './App';
import './index.css';
import './styles/user-theme.css';
import './styles/admin-theme.css';

// Set up Font Awesome library with only globally needed icons
// Landing-specific icons are imported directly in their components for code-splitting
library.add(
  faCheck,
  faUser,
  faCog,
  faSignOutAlt,
  faSpinner,
  faBars,
  faTimes,
  faChevronDown,
  faSearch,
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faDownload,
  faUpload,
  faEnvelope,
  faPhone,
  faCalendar,
  faClock,
  faExclamationTriangle,
  faInfoCircle,
  faQuestionCircle,
  faHome,
  faUsers,
  faArrowRight,
  faFilePdf,
  faFileImage,
  faFileMedical,
  faNotesMedical,
  faStethoscope,
  faHeartbeat,
  faLayerGroup
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>
);
